import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit';
import { Origin } from 'models/Origin';
import { RootState } from 'store';
import { apiGet } from 'utils/request';

export const fetchOrigins = createAsyncThunk('origins/fetchOrigins', async () => {
  const { data } = await apiGet<{ data: Origin[] }>(
    `/origins?limit=1000${
      process.env.REACT_APP_ENV !== 'production'
        ? '&responseType=selected'
        : '&responseType=full'
    }`,
    {
      action: 'getOrigins',
    },
  );

  return data;
});

interface State {
  data: Origin[];
  isLoading: boolean;
  error: SerializedError | null;
}

const initialState: State = {
  data: [],
  isLoading: false,
  error: null,
};

export const originsSlice = createSlice({
  name: 'origins',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchOrigins.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchOrigins.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.data = action.payload;
    });
    builder.addCase(fetchOrigins.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const selectOrigins = (state: RootState) => state.origins.data;
export const selectOriginsError = (state: RootState) => state.origins.error;
export const selectOriginsFetching = (state: RootState) => state.origins.isLoading;

export const reducer = originsSlice.reducer;
